import { render, staticRenderFns } from "./industryActivityInformation.vue?vue&type=template&id=b016bc72"
import script from "./industryActivityInformation.vue?vue&type=script&lang=js"
export * from "./industryActivityInformation.vue?vue&type=script&lang=js"
import style0 from "./industryActivityInformation.vue?vue&type=style&index=0&id=b016bc72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports